import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const REFRESH_INTERVAL = 2 * 60 * 1000;
let cachedData = null;
let fetchedAt = 0;
let pendingRequest = null;

function loadPrices() {
  if (cachedData && Date.now() - fetchedAt < REFRESH_INTERVAL) {
    return Promise.resolve(cachedData);
  }
  if (!pendingRequest) {
    pendingRequest = api.get("/widgets/precious-metals")
      .then(({ data }) => {
        cachedData = data;
        fetchedAt = Date.now();
        return data;
      })
      .catch(() => cachedData || { items: [], updated_at: null, available: false })
      .finally(() => { pendingRequest = null; });
  }
  return pendingRequest;
}

export default function usePreciousMetals() {
  const [data, setData] = useState(cachedData || { items: [], updated_at: null, available: false });

  useEffect(() => {
    let active = true;
    const refresh = async () => {
      const next = await loadPrices();
      if (active) setData(next);
    };

    refresh();
    const interval = setInterval(refresh, REFRESH_INTERVAL);
    return () => {
      active = false;
      clearInterval(interval);
    };
  }, []);

  return data;
}
